/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore',
	'../widgets/livewidget/nls/StringResources',
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit'
], function (View, _, stringResources, React, ReactDOM, Toolkit) {
	/* eslint react/prop-types: 0 */ // TODO: Remove once we have prop-types brought in from glass.

	const Menu = Toolkit.Menu;

	/**
	 * Wrapper around the Menu ui-toolkit item that we pass the list items into and handles the onchange
	 *
	 */
	class CustomGroupList extends React.Component{
		constructor(props){
			super(props);
			this.state = {
				selected: {}
			};
			this.removeView = props.removeView;
			this.menuContent = props.possibleItems;
		}

		/*
		 * Call the action associated with the current item selected
		 */
		_onChange(label, action) {
			action();
			this.removeView();
		}

		render() {
			return <Menu onChange={this._onChange.bind(this)} selected={this.state.selected}>
				<Menu.List content={this.menuContent} name="customGroupList"/>
			</Menu>;
		}
	}


	/**
	 * @classdesc  Creates a dropdown list for custom groups with the list items passed
	 *
	 * @public
	 *
	 * @param {object} options.listItems - The items to list
	 */

	class CustomGroupActionsListDialog extends View {
		constructor(options) {
			super(options);
			this.possibleItems = options.possibleItems;

			this._iWidth = '240';
		}

		remove() {
			const flyout = this.toolbar && this.toolbar.flyout;
			if (this.$el) {
				ReactDOM.unmountComponentAtNode(this.$el[0]);
			}
			this.viewState = null;
			if(flyout) {
				flyout.destroy();
			}
			super.remove();
		}

		/**
		 * @param  {Object} toolbar that the dialog is being rendered from.
		 */
		renderCallBack(toolbar) {
			this.toolbar = toolbar;
		}

		/**
		 * Needed so toolbar is set in NextView and the flyout can be closed when remove the dialog
		 */
		preload() {
			return Promise.resolve();
		}


		render() {
			this.$el.addClass('popoverDialogContainer customGroup')
				.width(this._iWidth + 'px');

			ReactDOM.render(
				<CustomGroupList possibleItems={this.possibleItems} removeView={this.remove.bind(this)} />,
				this.$el[0]);

			return this;
		}
	}

	return CustomGroupActionsListDialog;
});
